export const physicianLastNameValueGetter = (params: any) => {
  if (!params?.data?.physicianlastname) return '';

  const {
    data: { physicianlastname },
  } = params;
  return `${physicianlastname}`;
};
